import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BiometrieFingerprintStateService {
  private readonly _biometrieDateOlderThanMaxMonths$ = new BehaviorSubject<boolean>(false);

  get biometrieDateOlderThanMaxMonths$(): Observable<boolean> {
    return this._biometrieDateOlderThanMaxMonths$.asObservable();
  }

  setBiometrieDateOlderThanMaxMonths(value: boolean): void {
    this._biometrieDateOlderThanMaxMonths$.next(!!value);
  }
}
